import { useQuery } from "@tanstack/react-query";
import {  getPriceSearch } from "~services/PriceSearchServices";


export const useGetMapaMina = (idCliente, refetchKey) => {
  const data = useQuery(
    ["dataPriceSearch", idCliente, refetchKey],
    () => getPriceSearch(idCliente), 
    {
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false, 
      refetchOnReconnect: false, 
      onSuccess: () => { },
      
    }
  );

  return data;
};

